// Settings > Plan and Settings > Billing (specs 29).
const billingEn = {
  "settings.billing": "Billing",
  "settings.billing_hint": "Card, invoices and billing details",
  "bill.banner_past_due": "We couldn't collect your Sooquna subscription. Pay now to keep your store open.",
  "bill.banner_frozen": "Your store is frozen for an unpaid bill: shoppers can't see it and only billing works here. Pay now to reopen it.",
  "bill.status.trialing": "Free trial",
  "bill.status.active": "Active",
  "bill.status.past_due": "Payment due",
  "bill.status.frozen": "Frozen",
  "bill.status.paused": "Paused",
  "bill.status.cancelled": "Cancelled",
  "bill.frozen": "Your store is frozen for an unpaid bill of {amount}: shoppers see a password page. Pay now to reopen it at once. Unpaid stores close on {date}.",
  "bill.past_due": "Your last payment didn't go through. Pay or update your card before {date} to keep your store open.",
  "bill.cancelling": "Your subscription ends on {date}. Resume it before then to keep your store open.",
  "bill.checking": "Checking your payment with SkipCash…",
  "bill.paid_done": "Payment received. Thank you!",
  "bill.paid_pending": "We're still waiting for SkipCash to confirm your payment. This page updates when it does.",
  "bill.paid_failed": "The payment didn't go through. Try again or use another card.",
  "bill.next_charge": "Next charge: {amount} on {date}",
  "bill.card": "{brand} ending in {last4}",
  "bill.offline": "Online payment isn't available yet. We'll invoice you for payment by bank transfer.",
  "bill.pay_now": "Pay now",
  "bill.pay_amount": "Pay {amount}",
  "bill.resume": "Resume subscription",
  "bill.cancel": "Cancel subscription",
  "bill.cancel_title": "Cancel your subscription?",
  "bill.cancel_confirm": "Your store stays open until the end of the period you've paid for, then closes. You can resume until a couple of days before then.",
  "bill.usage": "Usage",
  "bill.meter_staff": "Staff accounts",
  "bill.meter_locations": "Locations",
  "bill.meter_languages": "Languages",
  "bill.meter_storage": "File storage",
  "bill.plan_locations": "{n} locations",
  "bill.your_plan": "Your plan",
  "bill.subscribe": "Subscribe",
  "bill.switch": "Switch to this plan",
  "bill.choose": "Choose plan",
  "bill.choose_title": "{plan} plan",
  "bill.due_now": "Due now",
  "bill.then": "Then {amount} a month, charged automatically from {date}.",
  "bill.credit_left": "{amount} of unused time is kept as credit on your account.",
  "bill.promo": "Promo code",
  "bill.apply": "Apply",
  "bill.redirect_note": "You'll pay securely on SkipCash's page and come straight back here.",
  "bill.payment_method": "Payment method",
  "bill.by_transfer": "Paid by bank transfer against our invoices.",
  "bill.no_card": "No card yet: it's added when you choose a plan.",
  "bill.update_card": "Update card",
  "bill.update_card_note": "Changing card takes a 5 QAR verification payment on SkipCash's page.",
  "bill.upcoming": "Upcoming",
  "bill.no_upcoming": "Nothing scheduled.",
  "bill.amount_due": "Amount due: {amount}",
  "bill.credits": "Account credit",
  "bill.credits_note": "Used automatically on your next plan payment.",
  "bill.invoices": "Invoices",
  "bill.no_invoices": "No invoices yet.",
  "bill.inv_number": "Invoice",
  "bill.inv_date": "Date",
  "bill.inv_status": "Status",
  "bill.inv_total": "Total",
  "bill.inv.draft": "Draft",
  "bill.inv.open": "Due",
  "bill.inv.paid": "Paid",
  "bill.inv.void": "Void",
  "bill.inv.uncollectible": "Not collected",
  "bill.refunded": "{amount} refunded",
  "bill.view": "View invoice",
  "bill.download": "Download PDF",
  "bill.profile": "Billing details",
  "bill.profile_hint": "Printed on the invoices Sooquna sends you.",
  "bill.legal_name": "Legal business name",
  "bill.billing_email": "Billing email",
  "bill.tax_id": "Tax registration number",
  "bill.phone": "Phone",
  "bill.address": "Address",
  "bill.city": "City",
};

export default billingEn;
